import React from 'react';
import './ComingSoonPage.css';

const features = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1" />
        <polyline points="16 6 12 2 8 6" />
        <line x1="12" y1="2" x2="12" y2="15" />
      </svg>
    ),
    title: 'Upload anything',
    body: 'PDFs, contracts, receipts, photos of handwritten notes. AI extracts and understands every word, table, and detail — automatically.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
      </svg>
    ),
    title: 'Ask anything',
    body: 'Chat naturally with your documents. Get precise, grounded answers drawn from exactly what you\'ve uploaded — not generic AI guesses.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    ),
    title: 'Instant insights',
    body: 'Every upload gets an AI-generated summary and key highlights the moment it lands. Know what\'s in your document before you even open it.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    title: 'Private by design',
    body: 'Your documents are encrypted and scoped to your account only. Nothing is shared, sold, or used to train any model.',
  },
];

const StoreBadges = () => (
  <div className="cs-badges">
    {/* Replace href values with real store links when published */}
    <a href="https://apps.apple.com" className="cs-badge" target="_blank" rel="noopener noreferrer" aria-label="Download on the App Store">
      <svg className="cs-badge-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11" />
      </svg>
      <span className="cs-badge-text">
        <span className="cs-badge-line1">Download on the</span>
        <span className="cs-badge-line2">App Store</span>
      </span>
    </a>
    <a href="https://play.google.com" className="cs-badge" target="_blank" rel="noopener noreferrer" aria-label="Get it on Google Play">
      <svg className="cs-badge-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M3 20.5v-17c0-.83.94-1.3 1.6-.8l14 8.5c.6.37.6 1.23 0 1.6l-14 8.5c-.66.5-1.6.03-1.6-.8z" />
      </svg>
      <span className="cs-badge-text">
        <span className="cs-badge-line1">Get it on</span>
        <span className="cs-badge-line2">Google Play</span>
      </span>
    </a>
  </div>
);

const ComingSoonPage = () => (
  <div className="cs-page">

    <section className="cs-hero">
      <p className="cs-eyebrow">AI-Powered Document Intelligence</p>
      <h1 className="cs-headline">Ask your documents<br />anything.</h1>
      <p className="cs-hero-sub">
        Upload a PDF, contract, receipt, or photo. Get precise, AI-powered answers
        grounded in exactly what you've shared — not generic responses.
        Free to start.
      </p>
      <StoreBadges />
    </section>

    <section className="cs-features">
      <div className="cs-features-grid">
        {features.map(({ icon, title, body }) => (
          <div key={title} className="cs-feature-card">
            <div className="cs-feature-icon">{icon}</div>
            <h3 className="cs-feature-title">{title}</h3>
            <p className="cs-feature-body">{body}</p>
          </div>
        ))}
      </div>
    </section>

    <section className="cs-cta">
      <p className="cs-cta-headline">The AI mind behind your documents.</p>
      <p className="cs-cta-sub">Available now on iOS and Android.</p>
      <StoreBadges />
    </section>

  </div>
);

export default ComingSoonPage;
